import { colorsPalettes } from '@similarweb/styles';
import { Button } from '@similarweb/ui-components';
import { Flex, Text } from '@similarweb/ui-components/foundations';
import { TimeCountingDiscount } from 'app/components/discountCampaign/DiscountBanner/TimeCountingDiscount/TimeCountingDiscount';
import { useSeasonalCampaign } from 'app/marketing/hooks/campaing-hooks/seasonal-campaign/useSeasonalCampaign';
import {
    CloseIconButton,
    Off,
    Percentage,
    SeasonCampaignWrapper
} from './StyledSeasonalCampaignBanner';
import { BusinessEfficiency, Close } from '@similarweb/icons';
import { SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS } from './translationKeys';
import { useTranslation } from 'pro-features/components/WithTranslation/src/I18n';
import { I18n } from '@similarweb/i18n-provider';
import { SEASONAL_CAMPAIGN_DISCOUNT_PERCENTAGE } from 'app/marketing/hooks/campaing-hooks/seasonal-campaign/useSeasonalCampaignTypes';
import { useSeasonalCampaignBanner } from './useSeasonalCampaignBanner';

export const SeasonalCampaignBanner = () => {
    const { promoCode, isUpgradedToAnnual, discountEndDate } = useSeasonalCampaign();
    const { isDiscarded, timerTheme, handleClose, onCtaClick } = useSeasonalCampaignBanner();

    const translate = useTranslation();

    const subTextKey = isUpgradedToAnnual
        ? SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS.subTextToAnnual
        : SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS.subText;

    if (isDiscarded) {
        return null;
    }

    return (
        <SeasonCampaignWrapper
            data-automation={`seasonal-campaign-banner-${isUpgradedToAnnual ? 'annual' : 'package'}`}
        >
            <Flex
                gap="24px"
                alignItems="center"
            >
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <BusinessEfficiency
                        color={colorsPalettes.orange[400]}
                        size={'sm'}
                    />

                    <Flex
                        alignItems="center"
                        gap="12px"
                    >
                        <Text
                            fontVariant="body1"
                            color={colorsPalettes.carbon[0]}
                        >
                            <I18n
                                dangerouslySetInnerHTML={true}
                                i18nKey={subTextKey}
                            />
                        </Text>
                        <Percentage>
                            {SEASONAL_CAMPAIGN_DISCOUNT_PERCENTAGE}%{' '}
                            <Off>{translate(SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS.off)}</Off>
                        </Percentage>
                        <Text
                            fontVariant="body1"
                            color={colorsPalettes.carbon[0]}
                        >
                            {translate(SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS.endsIn)}
                        </Text>
                    </Flex>

                    <TimeCountingDiscount
                        discountEndTime={discountEndDate}
                        bannerTheme={timerTheme}
                    />
                </Flex>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[0]}
                >
                    {translate(SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS.code)}:{' '}
                    <Text
                        fontVariant="body1"
                        color={colorsPalettes.orange[300]}
                    >
                        {promoCode}
                    </Text>
                </Text>
            </Flex>

            <Flex
                gap="12px"
                alignItems="center"
            >
                <Button
                    type="inverted"
                    onClick={onCtaClick}
                    color={colorsPalettes.midnight[600]}
                >
                    {translate(SEASONAL_CAMPAIGN_BANNER_TRANSLATION_KEYS.upgradeNow)}
                </Button>

                <CloseIconButton
                    type="flat"
                    onClick={handleClose}
                    data-automation={`campaign-promo-banner-close`}
                >
                    <Close
                        size="sm"
                        color={colorsPalettes.carbon[0]}
                    />
                </CloseIconButton>
            </Flex>
        </SeasonCampaignWrapper>
    );
};
